import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "tw3-flex tw3-min-h-screen tw3-items-center tw3-justify-center tw3-bg-surface-50 tw3-p-6 tw3-text-center tw3-text-surface-900"
}

import Toast from 'primevue/toast';

import BookingPage from '@/pages/booking/BookingPage.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickQuoteApp',
  setup(__props) {

const match = window.location.pathname.match(/^\/quick-quote\/([^/]+)\/?$/);
const apiKey = match?.[1] ? decodeURIComponent(match[1]) : '';
const isModal =
	new URLSearchParams(window.location.search).get('modal') === '1' &&
	window.parent !== window;

const closeModal = (): void => {
	window.parent.postMessage({ type: 'gb-quick-quote:close' }, '*');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(apiKey))
      ? (_openBlock(), _createBlock(BookingPage, {
          key: 0,
          apiKey: _unref(apiKey),
          closable: _unref(isModal),
          onClose: closeModal
        }, null, 8, ["apiKey", "closable"]))
      : (_openBlock(), _createElementBlock("main", _hoisted_1, _cache[0] || (_cache[0] = [
          _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "tw3-text-2xl tw3-font-bold" }, "Invalid booking link"),
            _createElementVNode("p", { class: "tw3-mt-2 tw3-text-sm tw3-text-surface-500" }, " Check the link and try again. ")
          ], -1)
        ]))),
    _createVNode(_unref(Toast), {
      position: "top-center",
      pt: { root: { style: 'top: 62px' } }
    })
  ], 64))
}
}

})